import { Link } from 'react-router-dom';
import { useAppStore } from '@/store';
import SearchInput from './SearchInput';
import Setting from './Setting';
import Wallet from './Wallet';
import Chain from './Chain';

export default () => {
  const {
    chainTokenAddressMap,
    chainInfo: { path },
  } = useAppStore();
  const tokenAddress = chainTokenAddressMap[path];
  return (
    <header className="p-[16px] flex flex-col gap-y-[12px]">
      <div className="flex justify-between">
        <div className="flex gap-x-[5px] items-center">
          <Link to={`/${path}/trade/${tokenAddress}`}>
            <img src="/icon/logo-sm.svg" alt="logo" className="w-[76px] h-[24px]" />
          </Link>
        </div>
        <div className="flex gap-x-[16px]">
          <SearchInput />
          <Setting />
          <Chain />
          <Wallet />
        </div>
      </div>
    </header>
  );
};
